<!--
 * @Autor: 毛萍萍
 * @Date: 2021-09-08 11:03:02
 * @LastEditTime: 2021-09-26 19:50:55
 * @LastEditors: 毛萍萍
 * @Description: 
 * @FilePath: \scim-edm-web\src\components\private\number-range\index.vue
-->
<template>
  <div class="number-range" :class="{'is-focus':isFocus}">
    <div class="number-range-input">
      <div class="range-min">
        <el-input :value="numValue[0]" @input="val => handleChange(val, 'min')" @focus="inputFocus" @blur="updateValue" :placeholder="startPlaceholder"></el-input>
      </div>
      <div class="range-to">-</div>
      <div class="range-max">
        <el-input :value="numValue[1]" @input="val => handleChange(val, 'max')" @focus="inputFocus" @blur="updateValue" :placeholder="endPlaceholder"></el-input>
      </div>
    </div>
    <div class="number-range-close">
      <span v-if="numValue.length" @click="resetData"><i class="el-icon-error"></i></span>
    </div>
  </div> 
</template>

<script>
export default {
  name: "NumberRange",
  props: {
    value: {
      required: true
    },
    placeholder: {
      type: String,
      default: ""
    },
    startPlaceholder: {
      type: String,
      default: "start"
    },
    endPlaceholder: {
      type: String,
      default: "end"
    }
  },  
  data(){
    return {
      numValue: [],
      isFocus: false,
    };
  },
  watch: {
    value() {
      this.setValue();
    }
  },
  created(){
    this.setValue();
  },
  methods: {
    // 设置numValue
    setValue(){
      if (this.value && Array.isArray(this.value)) {
        // if (this.value[0] !== "" && this.value[0] !== undefined && this.value[0] !== null) {
        //   this.$set(this.numValue, 0, this.value[0]);
        // }
        // if (this.value[1] !== "" && this.value[1] !== undefined && this.value[1] !== null) {
        //   this.$set(this.numValue, 1, this.value[1]);
        // }
        if (this.value.length === 2) {
          const val = this.compareMx(this.value);
          this.$set(this, "numValue", JSON.parse(JSON.stringify(val)));
        } else {
          this.$set(this, "numValue", JSON.parse(JSON.stringify(this.value)));
        }
      } else {
        this.$set(this, "numValue", []);
      }
    },
    // input值改变
    handleChange(val, type){
      if (type === "min") {
        this.$set(this.numValue, 0, String(val).replace(/[^\d]/g, ""));
      } else {
        this.$set(this.numValue, 1, String(val).replace(/[^\d]/g, ""));
      }
      // 判断数组中是否有值
      const existVal = this.numValue.some(o => o !== "" && o !== undefined && o !== null);
      if (!existVal) {
        this.$set(this, "numValue", []);
        this.$emit("input", JSON.parse(JSON.stringify(this.numValue)));
      } 
    },
    // 比较大小
    compareMx(val){
      if (val[0] !== undefined && val[0] !== "" && val[1] !== undefined && val[1] !== ""){
        const start = val[0];
        const end = val[1];
        if (Number(start) > Number(end)) {
          return val.reverse();
        } else {
          return val;
        }
      } else {
        return val;
      }
    },
    // input失去焦点
    updateValue(){
      this.isFocus = false;
      this.$emit("input", JSON.parse(JSON.stringify(this.numValue)));
    },
    inputFocus(){
      this.isFocus = true;
    },
    // 重置数据
    resetData(){
      this.$set(this, "numValue", []);
      this.$emit("input", JSON.parse(JSON.stringify(this.numValue)));
    }
  }
};
</script>

<style lang="scss">
 .number-range{
    position: relative;
    width: 100%;
    padding: 1px;
    padding-right: 50px;
    border: 1px solid #d4d9e2;

    .number-range-input{
      display: flex;
      height: 36px;
      line-height: 36px;
      flex-direction: row;
      align-items: center;
    }

    .range-min,
    .range-max{
      flex: 1;

      .el-input__inner{
        height: 100%;
        line-height: 38px;
        border-width: 0;
      }
    }

    .range-to{
      margin: 0 10px;
    }

    .number-range-close{
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      display: none;
      width: 50px;
      padding-right: 5px;
      color: #c6ccd7;
      text-align: right;
      cursor: pointer;

      &:hover{
        color: #9ea5b2;
      }
    }
    
    &:hover{
      border-color: #00b259;

      .number-range-close{
        display: block;
      }
    }

    &.is-focus{
      border-color: #00b259;
      border-width: 1px;
      box-shadow: inset 0 0 0 1px #00b259;

       .number-range-close{
        display: block;
      }
    }

  }
</style>
